import { SourceEntityTypeEnum } from '@issuemanager/constants';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export interface SourceEntityTypeData {
  value: string;
  label: string;
}

export function useSourceEntityTypes(): SourceEntityTypeData[] {
  const { t } = useTranslation();

  const sourceEntityTypes: SourceEntityTypeData[] = useMemo(
    () =>
      Object.entries(SourceEntityTypeEnum).map(([_key, value]) => ({
        value,
        label: t(`sourceEntityTypes.${value}`),
      })),
    [t],
  );

  return sourceEntityTypes;
}
